import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Income Statement
export const getIncomeStatement = createAsyncThunk(
  "accountingReports/getIncomeStatement",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/income-statement`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Customer Statement
export const getCustomerStatement = createAsyncThunk(
  "accountingReports/getCustomerStatement",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/customer-statement`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Vendor Statement
export const getVendorStatement = createAsyncThunk(
  "accountingReports/getVendorStatement",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/vendor-statement`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Balance Sheet
export const getBalanceSheet = createAsyncThunk(
  "accountingReports/getBalanceSheet",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/balance-sheet`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Cash Flow Statement
export const getCashFlowStatement = createAsyncThunk(
  "accountingReports/getCashFlowStatement",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/cash-flow-statement`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Customer Aging
export const getCustomerAging = createAsyncThunk(
  "accountingReports/getCustomerAging",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/customer-aging`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Vendor Aging
export const getVendorAging = createAsyncThunk(
  "accountingReports/getVendorAging",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/vendor-aging`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// General Ledger
export const getGeneralLedger = createAsyncThunk(
  "accountingReports/getGeneralLedger",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/general-ledger`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Cost Center Report
export const getCostCenterReport = createAsyncThunk(
  "accountingReports/getCostCenterReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounting-reports/cost-center-report`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Account Statement
export const getAccountStatementReport = createAsyncThunk(
  "accountingReports/getAccountStatementReport",
  async ({ accountId, params = {} }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(
        `${BASE_URL}/accounts/${accountId}/statement`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);
// get cost centers (for dropdown)
export const getCostCenters = createAsyncThunk(
  "accountingReports/getCostCenters",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(`${BASE_URL}/cost-centers`, {
        params: { per_page: 1000, ...params },
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Get Accounts report
export const getAccountsForReport = createAsyncThunk(
  "accountingReports/getAccountsForReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(`${BASE_URL}/accounts/tree`, {
        params: { per_page: 1000, ...params },
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Get Customers (for dropdown)
export const getCustomersForReport = createAsyncThunk(
  "accountingReports/getCustomersForReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(`${BASE_URL}/customers`, {
        params: { per_page: 1000, ...params },
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

// Get Vendors (for dropdown)
export const getVendorsForReport = createAsyncThunk(
  "accountingReports/getVendorsForReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      const response = await axios.get(`${BASE_URL}/vendors`, {
        params: { per_page: 1000, ...params },
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  incomeStatement: null,
  customerStatement: null,
  vendorStatement: null,
  balanceSheet: null,
  cashFlowStatement: null,
  customerAging: null,
  vendorAging: null,
  generalLedger: null,
  costCenterReport: null,
  accountStatementReport: null,
  costCenters: [],
  costCentersMeta: null,
  accounts: [],
  customers: [],
  vendors: [],
  vendorMeta: null,
  vendorLinks: null,
  isLoading: false,
  error: null,
  success: null,
};

const accountingReportsSlice = createSlice({
  name: "accountingReports",
  initialState,
  reducers: {
    hydrate: (state, action) => {
      // Hydrate state from persisted storage
      if (action.payload) {
        return { ...state, ...action.payload };
      }
      return state;
    },
    clearError: state => {
      state.error = null;
    },
    clearSuccess: state => {
      state.success = null;
    },
    clearIncomeStatement: state => {
      state.incomeStatement = null;
    },
    clearCustomerStatement: state => {
      state.customerStatement = null;
    },
    clearVendorStatement: state => {
      state.vendorStatement = null;
    },
    clearBalanceSheet: state => {
      state.balanceSheet = null;
    },
    clearCashFlowStatement: state => {
      state.cashFlowStatement = null;
    },
    clearCustomerAging: state => {
      state.customerAging = null;
    },
    clearVendorAging: state => {
      state.vendorAging = null;
    },
    clearGeneralLedger: state => {
      state.generalLedger = null;
    },
    clearCostCenterReport: state => {
      state.costCenterReport = null;
    },
    clearAccountStatementReport: state => {
      state.accountStatementReport = null;
    },
  },
  extraReducers: builder => {
    builder
      // Income Statement
      .addCase(getIncomeStatement.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getIncomeStatement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.incomeStatement = action.payload;
        state.success =
          action.payload?.message ||
          "accountingReports.incomeStatementRetrievedSuccessfully";
      })
      .addCase(getIncomeStatement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve income statement";
      })
      // Customer Statement
      .addCase(getCustomerStatement.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCustomerStatement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customerStatement = action.payload;
        state.success =
          action.payload?.message ||
          "Customer statement retrieved successfully";
      })
      .addCase(getCustomerStatement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve customer statement";
      })
      // Vendor Statement
      .addCase(getVendorStatement.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVendorStatement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.vendorStatement = action.payload;
        state.success =
          action.payload?.message || "Vendor statement retrieved successfully";
      })
      .addCase(getVendorStatement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve vendor statement";
      })
      // Balance Sheet
      .addCase(getBalanceSheet.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBalanceSheet.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balanceSheet = action.payload;
        state.success =
          action.payload?.message || "Balance sheet retrieved successfully";
      })
      .addCase(getBalanceSheet.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve balance sheet";
      })
      // Cash Flow Statement
      .addCase(getCashFlowStatement.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCashFlowStatement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cashFlowStatement = action.payload;
        state.success =
          action.payload?.message ||
          "Cash flow statement retrieved successfully";
      })
      .addCase(getCashFlowStatement.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || "Failed to retrieve cash flow statement";
      })
      // Customer Aging
      .addCase(getCustomerAging.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCustomerAging.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customerAging = action.payload;
        state.success =
          action.payload?.message || "Customer aging retrieved successfully";
      })
      .addCase(getCustomerAging.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve customer aging";
      })
      // Vendor Aging
      .addCase(getVendorAging.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVendorAging.fulfilled, (state, action) => {
        state.isLoading = false;
        state.vendorAging = action.payload;
        state.success =
          action.payload?.message || "Vendor aging retrieved successfully";
      })
      .addCase(getVendorAging.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve vendor aging";
      })
      // General Ledger
      .addCase(getGeneralLedger.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getGeneralLedger.fulfilled, (state, action) => {
        state.isLoading = false;
        state.generalLedger = action.payload;
        state.success =
          action.payload?.message || "General ledger retrieved successfully";
      })
      .addCase(getGeneralLedger.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve general ledger";
      })
      // Cost Center Report
      .addCase(getCostCenterReport.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCostCenterReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.costCenterReport = action.payload;
        state.success =
          action.payload?.message ||
          "Cost center report retrieved successfully";
      })
      .addCase(getCostCenterReport.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve cost center report";
      })
      // Account Statement Report
      .addCase(getAccountStatementReport.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAccountStatementReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accountStatementReport = action.payload;
        state.success =
          action.payload?.message || "Account statement retrieved successfully";
      })
      .addCase(getAccountStatementReport.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to retrieve account statement";
      })
      // Cost Centers
      .addCase(getCostCenters.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCostCenters.fulfilled, (state, action) => {
        state.isLoading = false;
        const responseData = action.payload?.data || action.payload;
        const data = Array.isArray(responseData)
          ? responseData
          : Array.isArray(responseData?.data)
            ? responseData.data
            : [];
        state.costCenters = data;
        state.costCentersMeta = action.payload?.meta || null;
      })
      .addCase(getCostCenters.rejected, state => {
        state.isLoading = false;
        state.costCenters = [];
        state.costCentersMeta = null;
      })
      // Accounts
      .addCase(getAccountsForReport.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAccountsForReport.fulfilled, (state, action) => {
        state.isLoading = false;
        const data =
          action.payload?.data?.data || action.payload?.data || action.payload;
        state.accounts = Array.isArray(data) ? data : [];
      })
      .addCase(getAccountsForReport.rejected, state => {
        state.isLoading = false;
        state.accounts = [];
      })
      // Customers
      .addCase(getCustomersForReport.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCustomersForReport.fulfilled, (state, action) => {
        state.isLoading = false;
        const data =
          action.payload?.data?.data || action.payload?.data || action.payload;
        state.customers = Array.isArray(data) ? data : [];
      })
      .addCase(getCustomersForReport.rejected, state => {
        state.isLoading = false;
        state.customers = [];
      })
      // Vendors
      .addCase(getVendorsForReport.pending, state => {
        state.isLoading = true;
      })
      .addCase(getVendorsForReport.fulfilled, (state, action) => {
        state.isLoading = false;
        const data =
          action.payload?.data?.data || action.payload?.data || action.payload;
        const meta = action.payload?.data?.meta || action.payload?.meta || null;
        const links =
          action.payload?.data?.links || action.payload?.links || null;
        state.vendors = Array.isArray(data) ? data : [];
        state.vendorMeta = meta;
        state.vendorLinks = links;
      })
      .addCase(getVendorsForReport.rejected, state => {
        state.isLoading = false;
        state.vendors = [];
        state.vendorMeta = null;
        state.vendorLinks = null;
      });
  },
});

export const {
  clearError,
  clearSuccess,
  clearIncomeStatement,
  clearCustomerStatement,
  clearVendorStatement,
  clearBalanceSheet,
  clearCashFlowStatement,
  clearCustomerAging,
  clearVendorAging,
  clearGeneralLedger,
  clearCostCenterReport,
  clearAccountStatementReport,
} = accountingReportsSlice.actions;

export default accountingReportsSlice.reducer;
